// removed by extract-text-webpack-plugin
module.exports = {"title-wrapper":"title-wrapper","titleWrapper":"title-wrapper","email-sent-success":"email-sent-success","emailSentSuccess":"email-sent-success","error-message-wrapper":"error-message-wrapper","errorMessageWrapper":"error-message-wrapper","eula-title":"eula-title","eulaTitle":"eula-title","eula-wrapper":"eula-wrapper","eulaWrapper":"eula-wrapper","eula-content":"eula-content","eulaContent":"eula-content","form":"form"};


//////////////////
// WEBPACK FOOTER
// ./src/components/account/forgotPasswordFlow/resetPasswordForm/style.scss
// module id = 1644
// module chunks = 0